/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 * 
 *  The JSON representation for `NullValue` is JSON `null`.
 */
export enum GoogleProtobuf_NullValue {
  NULL_VALUE = "NULL_VALUE",
}

export enum OdProtosCasaData_GeoAccuracy {
  GEO_APPROXIMATE = "GEO_APPROXIMATE",
  GEO_ERROR = "GEO_ERROR",
  GEO_ROOFTOP = "GEO_ROOFTOP",
  GEO_ROOFTOP_INTERPOLATED = "GEO_ROOFTOP_INTERPOLATED",
  GEO_STREET_LEVEL = "GEO_STREET_LEVEL",
  GEO_UNKNOWN = "GEO_UNKNOWN",
}

export enum OdProtosCasaData_Result {
  ADDRESS_COMING_SOON = "ADDRESS_COMING_SOON",
  ADDRESS_EXTRANEOUS_INPUT = "ADDRESS_EXTRANEOUS_INPUT",
  ADDRESS_INVALID = "ADDRESS_INVALID",
  ADDRESS_INVALID_BOX_NUMBER = "ADDRESS_INVALID_BOX_NUMBER",
  ADDRESS_INVALID_PREMISE = "ADDRESS_INVALID_PREMISE",
  ADDRESS_INVALID_STREET = "ADDRESS_INVALID_STREET",
  ADDRESS_INVALID_SUB_PREMISE = "ADDRESS_INVALID_SUB_PREMISE",
  ADDRESS_MISSING_BOX_NUMBER = "ADDRESS_MISSING_BOX_NUMBER",
  ADDRESS_MISSING_PREMISE = "ADDRESS_MISSING_PREMISE",
  ADDRESS_MISSING_SUB_PREMISE = "ADDRESS_MISSING_SUB_PREMISE",
  ADDRESS_NIL = "ADDRESS_NIL",
  ADDRESS_NOT_REAL = "ADDRESS_NOT_REAL",
  ADDRESS_NOT_SUPPORTED = "ADDRESS_NOT_SUPPORTED",
  ADDRESS_UNKNOWN = "ADDRESS_UNKNOWN",
  ADDRESS_VACANT = "ADDRESS_VACANT",
  ADDRESS_VALID = "ADDRESS_VALID",
  ADDRESS_VALID_STREET = "ADDRESS_VALID_STREET",
}

/**
 * References the relationship between an Opendoor and the partner.
 * Next ID: 14
 */
export enum OdProtosPartnershipData_PartnershipType {
  AGENT_BROKERAGE = "AGENT_BROKERAGE",
  AGENT_TECH_INTEGRATION = "AGENT_TECH_INTEGRATION",
  CORPORATE_BENEFITS = "CORPORATE_BENEFITS",
  CREDIT_AND_DEBT = "CREDIT_AND_DEBT",
  HOME_BUILDER = "HOME_BUILDER",
  INDEPENDENT_DEVELOPER = "INDEPENDENT_DEVELOPER",
  LENDER = "LENDER",
  MARKETING = "MARKETING",
  MLS = "MLS",
  ONLINE_REAL_ESTATE = "ONLINE_REAL_ESTATE",
  REAL_ESTATE_AGENCY = "REAL_ESTATE_AGENCY",
  REIT = "REIT",
  TEST_PARTNER = "TEST_PARTNER",
  UNKNOWN = "UNKNOWN",
}

/**
 * Denial reason if the customer was denied for a product.
 * Next ID: 74
 */
export enum OdProtosSellCommon_DenialReason {
  ACTIVE_OFFER = "ACTIVE_OFFER",
  ADDRESS = "ADDRESS",
  ADDRESS_OVERRIDE = "ADDRESS_OVERRIDE",
  AGENT_RELATION = "AGENT_RELATION",
  AGE_RESTRICTED_COMMUNITY = "AGE_RESTRICTED_COMMUNITY",
  AGE_RESTRICTED_SEASONAL = "AGE_RESTRICTED_SEASONAL",
  ASBESTOS_SIDING = "ASBESTOS_SIDING",
  BEFORE_1960 = "BEFORE_1960",
  BELOW_MARKET_RATE_OWNERSHIP = "BELOW_MARKET_RATE_OWNERSHIP",
  BUYER_UNAVAILABLE = "BUYER_UNAVAILABLE",
  CESSPOOL = "CESSPOOL",
  COVID_19 = "COVID_19",
  DENIED_FOR_OPENDOOR_DIRECT = "DENIED_FOR_OPENDOOR_DIRECT",
  DENIED_FOR_SELL_WITH_UPSIDE = "DENIED_FOR_SELL_WITH_UPSIDE",
  DEPENDENT_RULESET = "DEPENDENT_RULESET",
  DUPLICATE_LEAD = "DUPLICATE_LEAD",
  DWELLING_TYPE = "DWELLING_TYPE",
  EXPECTED_LGM = "EXPECTED_LGM",
  FEES_TOO_HIGH = "FEES_TOO_HIGH",
  FIRE_DAMAGE = "FIRE_DAMAGE",
  FLOOD_HISTORY = "FLOOD_HISTORY",
  FLOOD_ZONE = "FLOOD_ZONE",
  FOUNDATION = "FOUNDATION",
  GATED_COMMUNITY = "GATED_COMMUNITY",
  GUARD_GATED_COMMUNITY = "GUARD_GATED_COMMUNITY",
  INELIGIBLE_HOA = "INELIGIBLE_HOA",
  IN_CONTRACT_WITH_OPENDOOR = "IN_CONTRACT_WITH_OPENDOOR",
  LACK_OF_ADEQUATE_COMPS = "LACK_OF_ADEQUATE_COMPS",
  LEASED_SOLAR_PANELS = "LEASED_SOLAR_PANELS",
  LISTED_BY_OPENDOOR = "LISTED_BY_OPENDOOR",
  LIVESTOCK = "LIVESTOCK",
  LOT_SQ_FT = "LOT_SQ_FT",
  MLS_LISTING_STATUS = "MLS_LISTING_STATUS",
  MOBILE_MANUFACTURED_HOME = "MOBILE_MANUFACTURED_HOME",
  NON_BUYBOX_DWELLING_TYPE = "NON_BUYBOX_DWELLING_TYPE",
  NON_SERIOUS_SELLER = "NON_SERIOUS_SELLER",
  NOT_IN_AUTODENIAL_LISTING_EXP = "NOT_IN_AUTODENIAL_LISTING_EXP",
  NOT_IN_LWOD_PILOT = "NOT_IN_LWOD_PILOT",
  NOT_IN_SELL_WITH_UPSIDE_PILOT = "NOT_IN_SELL_WITH_UPSIDE_PILOT",
  NOT_IN_SIDE_BY_SIDE_EXP = "NOT_IN_SIDE_BY_SIDE_EXP",
  NO_DENIAL = "NO_DENIAL",
  OFFER_IN_PROGRESS = "OFFER_IN_PROGRESS",
  OFFER_OUTLIER = "OFFER_OUTLIER",
  OTHER_DENIAL = "OTHER_DENIAL",
  OTHER_DENIAL_DETAIL = "OTHER_DENIAL_DETAIL",
  OTHER_DENIAL_GENERAL = "OTHER_DENIAL_GENERAL",
  OTHER_HIGH_RISK = "OTHER_HIGH_RISK",
  OWNED_BY_OPENDOOR = "OWNED_BY_OPENDOOR",
  PARTNERSHIP = "PARTNERSHIP",
  POLYBUTYLENE_PIPING = "POLYBUTYLENE_PIPING",
  PREPARING_OFFER = "PREPARING_OFFER",
  PRIVATE_POOL = "PRIVATE_POOL",
  QUALIFIED_FOR_LWOD = "QUALIFIED_FOR_LWOD",
  QUALIFIED_FOR_OPENDOOR_DIRECT = "QUALIFIED_FOR_OPENDOOR_DIRECT",
  RESERVED_FOR_EXTERNAL_BROKER = "RESERVED_FOR_EXTERNAL_BROKER",
  SALE_TIMELINE = "SALE_TIMELINE",
  SELLER_TRIAGE = "SELLER_TRIAGE",
  SEPTIC = "SEPTIC",
  SHARED_ENTRANCE = "SHARED_ENTRANCE",
  SHARED_LOT = "SHARED_LOT",
  TENANT_OCCUPIED = "TENANT_OCCUPIED",
  TRADE_IN = "TRADE_IN",
  UNABLE_TO_VALUE = "UNABLE_TO_VALUE",
  UNDERGROUND_OIL_TANK = "UNDERGROUND_OIL_TANK",
  UNIQUE_OWNERSHIP_STRUCTURE = "UNIQUE_OWNERSHIP_STRUCTURE",
  UNPERMITTED_ADDITION = "UNPERMITTED_ADDITION",
  VALUATION_TOO_HIGH = "VALUATION_TOO_HIGH",
  VALUATION_TOO_LOW = "VALUATION_TOO_LOW",
  VALUATION_TOO_LOW_LISTED = "VALUATION_TOO_LOW_LISTED",
  WELL_WATER = "WELL_WATER",
  WORKING_WITH_HOMEBUILDER = "WORKING_WITH_HOMEBUILDER",
  YEAR_BUILT = "YEAR_BUILT",
}

/**
 * A Product that we can offer to the seller.
 * Next ID: 11
 */
export enum OdProtosSellCommon_Product {
  AGENT_REFERRAL = "AGENT_REFERRAL",
  BUY_WITH_OPENDOOR = "BUY_WITH_OPENDOOR",
  EXTERNAL_LISTING_AGENT = "EXTERNAL_LISTING_AGENT",
  LIST_WITH_CERTAINTY = "LIST_WITH_CERTAINTY",
  LIST_WITH_OPENDOOR = "LIST_WITH_OPENDOOR",
  OPENDOOR_BACKED_OFFERS = "OPENDOOR_BACKED_OFFERS",
  OPENDOOR_DIRECT = "OPENDOOR_DIRECT",
  REIT = "REIT",
  SELL_WITH_EXCLUSIVES = "SELL_WITH_EXCLUSIVES",
  SELL_WITH_UPSIDE = "SELL_WITH_UPSIDE",
  UNKNOWN_PRODUCT = "UNKNOWN_PRODUCT",
}

/**
 * SelfServiceVirtualAssessmentExperimentGroup determines what experiment group the seller is in with regards to the Self Service
 * Virtual Assessment Experiment, where the seller has the option to upload a set of recordings of their home
 * in order to finalize their headline price. Depending on what group the seller falls into will determine
 * the user experience in terms of how they're presented with this option.
 * Next ID: 6
 */
export enum OdProtosSellCommon_SelfServiceVirtualAssessmentExperimentGroup {
  AGENT_ASSERTIVE = "AGENT_ASSERTIVE",
  AGENT_CONTROL = "AGENT_CONTROL",
  ASSERTIVE = "ASSERTIVE",
  BALANCED = "BALANCED",
  CONTROL = "CONTROL",
  NOT_IN_EXPERIMENT = "NOT_IN_EXPERIMENT",
}

export enum OdProtosSellReceptionData_SellerInput_AddressVerifiedStatus {
  AUTO_VERIFIED = "AUTO_VERIFIED",
  CONFIRMED_VERIFIED = "CONFIRMED_VERIFIED",
  NOT_VERIFIED = "NOT_VERIFIED",
}

/**
 * Next ID: 4
 */
export enum OdProtosSellReceptionData_SellerInput_AnalyticsMetadata_Product {
  OPENDOOR_COMPLETE = "OPENDOOR_COMPLETE",
  OPENDOOR_EXCLUSIVES = "OPENDOOR_EXCLUSIVES",
  SELL_DIRECT = "SELL_DIRECT",
  UNKNOWN = "UNKNOWN",
}

/**
 * The channel the seller came in from, used to determine the overall experience
 * the seller will go through.
 * Next ID: 19
 */
export enum OdProtosSellReceptionData_SellerInput_Channel {
  AGENT_REQUEST = "AGENT_REQUEST",
  AGENT_REQUEST_LISTED = "AGENT_REQUEST_LISTED",
  APP = "APP",
  BUY_SELL_FLOW = "BUY_SELL_FLOW",
  CAKE_LANDING_PAGE = "CAKE_LANDING_PAGE",
  DEFAULT = "DEFAULT",
  EMAIL_PROSPECTING = "EMAIL_PROSPECTING",
  EXCLUSIVE_OFFERS = "EXCLUSIVE_OFFERS",
  FLYWHEEL = "FLYWHEEL",
  HOME_RESERVE = "HOME_RESERVE",
  HOME_VALUE = "HOME_VALUE",
  OPENDOOR_BACKED_OFFER = "OPENDOOR_BACKED_OFFER",
  OUTBOUND_OFFERS_LISTED = "OUTBOUND_OFFERS_LISTED",
  PARTNER_API = "PARTNER_API",
  REIT_BULK_REQUEST = "REIT_BULK_REQUEST",
  REIT_BULK_REQUEST_LISTED = "REIT_BULK_REQUEST_LISTED",
  SELLER_REQUEST_LISTED = "SELLER_REQUEST_LISTED",
  TRADE_IN = "TRADE_IN",
  UNSET_CHANNEL = "UNSET_CHANNEL",
}

export enum OdProtosValidataData_ConfidenceLevel {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  UNKNOWN = "UNKNOWN",
}

export enum OdProtosValidataData_ConfidenceReason {
  CONFIDENCE_REASON_CONFLICITING_INTERNAL_EDITS = "CONFIDENCE_REASON_CONFLICITING_INTERNAL_EDITS",
  CONFIDENCE_REASON_CONFLICTING_DATA = "CONFIDENCE_REASON_CONFLICTING_DATA",
  CONFIDENCE_REASON_CONFLICTING_FLOOR_PLAN_SCAN = "CONFIDENCE_REASON_CONFLICTING_FLOOR_PLAN_SCAN",
  CONFIDENCE_REASON_COULD_NOT_VERIFY = "CONFIDENCE_REASON_COULD_NOT_VERIFY",
  CONFIDENCE_REASON_EXTERNAL_SOURCES_AGREE = "CONFIDENCE_REASON_EXTERNAL_SOURCES_AGREE",
  CONFIDENCE_REASON_INTERNALLY_VERIFIED = "CONFIDENCE_REASON_INTERNALLY_VERIFIED",
  CONFIDENCE_REASON_NO_DATA = "CONFIDENCE_REASON_NO_DATA",
  CONFIDENCE_REASON_UNKNOWN = "CONFIDENCE_REASON_UNKNOWN",
}

export enum OdProtosWebData_LeadSource_Type {
  PARTNERSHIP = "PARTNERSHIP",
  RECEPTION = "RECEPTION",
  UNKNOWN_TYPE = "UNKNOWN_TYPE",
}

/**
 * List of known participant roles in web, from web/app/models/concerns/participant_roles.rb
 */
export enum OdProtosWebData_ParticipantRole {
  ACQ_AE = "ACQ_AE",
  ACQ_AGENT = "ACQ_AGENT",
  ACQ_CX = "ACQ_CX",
  ACQ_EM = "ACQ_EM",
  ACQ_SDR = "ACQ_SDR",
  ACQ_TC = "ACQ_TC",
  BROKER = "BROKER",
  CONSISTENT_VALUATIONS = "CONSISTENT_VALUATIONS",
  ESTIMATOR = "ESTIMATOR",
  FINANCE_TC = "FINANCE_TC",
  HOLDING_SUPPORT = "HOLDING_SUPPORT",
  HPM = "HPM",
  INITIATOR = "INITIATOR",
  OUTLIER_VALUATIONS = "OUTLIER_VALUATIONS",
  PORTFOLIO_MANAGER = "PORTFOLIO_MANAGER",
  RENO_MANAGER = "RENO_MANAGER",
  RESALE_ACX = "RESALE_ACX",
  RESALE_AGENT = "RESALE_AGENT",
  RESALE_CC = "RESALE_CC",
  RESALE_CX_SALES = "RESALE_CX_SALES",
  RESALE_CX_SALES_ASSOCIATE = "RESALE_CX_SALES_ASSOCIATE",
  RESALE_CX_VISITOR = "RESALE_CX_VISITOR",
  RESALE_TC = "RESALE_TC",
  ROLE_UNKNOWN = "ROLE_UNKNOWN",
  SECURITY_SUPPORT = "SECURITY_SUPPORT",
  SELLER_PARTICIPANT = "SELLER_PARTICIPANT",
  SIGNATORY = "SIGNATORY",
  SOFT_RESALE_ACX = "SOFT_RESALE_ACX",
  SYSTEM = "SYSTEM",
  TC_SUPPORT = "TC_SUPPORT",
  UNDERWRITER = "UNDERWRITER",
  UTILITY_SUPPORT = "UTILITY_SUPPORT",
  VALUATIONS = "VALUATIONS",
  VENDOR_DRIVER = "VENDOR_DRIVER",
}

export interface ExperimentVariationInput {
  name: string;
  shouldTriggerImpression: boolean;
}

/**
 * `ListValue` is a wrapper around a repeated field of values.
 * 
 * The JSON representation for `ListValue` is JSON array.
 */
export interface GoogleProtobuf_ListValueInput {
  values?: GoogleProtobuf_ValueInput[] | null;
}

/**
 * `Struct` represents a structured data value, consisting of fields
 * which map to dynamically typed values. In some languages, `Struct`
 * might be supported by a native representation. For example, in
 * scripting languages like JS a struct is represented as an
 * object. The details of that representation are described together
 * with the proto support for the language.
 * 
 * The JSON representation for `Struct` is JSON object.
 */
export interface GoogleProtobuf_StructInput {
  fields?: GoogleProtobuf_Struct_FieldsEntryInput[] | null;
}

/**
 * `GoogleProtobuf_Struct_FieldsEntryInput` represents the `fields` map in `google.protobuf.Struct`.
 */
export interface GoogleProtobuf_Struct_FieldsEntryInput {
  key?: string | null;
  value?: GoogleProtobuf_ValueInput | null;
}

/**
 * `Value` represents a dynamically typed value which can be either
 * null, a number, a string, a boolean, a recursive struct value, or a
 * list of values. A producer of value is expected to set one of these
 * variants. Absence of any variant indicates an error.
 * 
 * The JSON representation for `Value` is JSON value.
 */
export interface GoogleProtobuf_ValueInput {
  kind?: GoogleProtobuf_Value_KindOneofInput | null;
}

export interface GoogleProtobuf_Value_KindOneofInput {
  nullValue?: GoogleProtobuf_NullValue | null;
  numberValue?: number | null;
  stringValue?: string | null;
  boolValue?: boolean | null;
  structValue?: GoogleProtobuf_StructInput | null;
  listValue?: GoogleProtobuf_ListValueInput | null;
}

/**
 * Next ID: 32
 */
export interface OdProtosCasaData_AddressInput {
  uuid: string;
  street?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  unitType?: string | null;
  unitNumber?: string | null;
  country?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  updatedToUuid?: string | null;
  isMissingUnitNumber?: boolean | null;
  county?: string | null;
  geoAccuracy?: OdProtosCasaData_GeoAccuracy | null;
  result?: OdProtosCasaData_Result[] | null;
  timeZone?: string | null;
  zipPlus4?: string | null;
  censusBlock?: string | null;
  censusTract?: string | null;
  countyFips?: string | null;
  placeName?: string | null;
  lastLine?: string | null;
}

export interface OdProtosFenceServices_GetRegionsFromAddressRequest_AddressOneofInput {
  addressUuid?: string | null;
  casaAddress?: OdProtosCasaData_AddressInput | null;
}

/**
 * Params for creating a seller input.
 * Next ID: 12
 */
export interface OdProtosReceptionServices_CreateSellerInputRequestInput {
  address?: OdProtosReceptionServices_SellerAddressInput | null;
  channel?: OdProtosSellReceptionData_SellerInput_Channel | null;
  trackingData?: OdProtosReceptionServices_CreateSellerInputRequest_TrackingDataInput[] | null;
  sellerFlowUuidOverride?: string | null;
  partnerReferralId?: string | null;
  sellerFlowNameOverride?: string | null;
  experimentEntityId?: string | null;
  isTradeInDashboard?: boolean | null;
  covid19Whitelist?: boolean | null;
  oldSellerInputUuid?: string | null;
  analyticsMetadata?: OdProtosSellReceptionData_SellerInput_AnalyticsMetadataInput | null;
}

/**
 * Cookie based tracking keywords to associate with the seller input.
 */
export interface OdProtosReceptionServices_CreateSellerInputRequest_TrackingDataInput {
  keyword?: string | null;
  trackedAt?: any | null;
}

/**
 * Address inputs for creating or updating a seller input.
 */
export interface OdProtosReceptionServices_SellerAddressInput {
  uuid?: string | null;
  street?: string | null;
  unit?: string | null;
  city?: string | null;
  postalCode?: string | null;
  state?: string | null;
}

/**
 * Next ID: 2
 */
export interface OdProtosSellReceptionData_SellerInput_AnalyticsMetadataInput {
  addressEntry?: OdProtosSellReceptionData_SellerInput_AnalyticsMetadata_AddressEntryInput | null;
}

export interface OdProtosSellReceptionData_SellerInput_AnalyticsMetadata_AddressEntryInput {
  product?: OdProtosSellReceptionData_SellerInput_AnalyticsMetadata_Product | null;
  url?: string | null;
}

/**
 * Grain is used to identify the entity that will be bucketed and supports multiple identifiers.
 * Next ID: 4
 */
export interface OdProtosVariantData_GrainInput {
  id?: OdProtosVariantData_Grain_IdOneofInput | null;
  grain?: OdProtosVariantData_Grain_GrainOneofInput | null;
}

export interface OdProtosVariantData_Grain_CustomerGrainInput {
  primaryId?: OdProtosVariantData_Grain_CustomerGrain_PrimaryIdOneofInput | null;
  temporaryId?: OdProtosVariantData_Grain_CustomerGrain_TemporaryIdOneofInput | null;
}

export interface OdProtosVariantData_Grain_CustomerGrain_PrimaryIdOneofInput {
  customerUuid?: string | null;
}

export interface OdProtosVariantData_Grain_CustomerGrain_TemporaryIdOneofInput {
  anonymousId?: string | null;
}

export interface OdProtosVariantData_Grain_GrainOneofInput {
  customer?: OdProtosVariantData_Grain_CustomerGrainInput | null;
  property?: OdProtosVariantData_Grain_PropertyGrainInput | null;
  operator?: OdProtosVariantData_Grain_OperatorGrainInput | null;
}

export interface OdProtosVariantData_Grain_IdOneofInput {
  customerUuid?: string | null;
  anonymousId?: string | null;
}

export interface OdProtosVariantData_Grain_OperatorGrainInput {
  primaryId?: OdProtosVariantData_Grain_OperatorGrain_PrimaryIdOneofInput | null;
}

export interface OdProtosVariantData_Grain_OperatorGrain_PrimaryIdOneofInput {
  humanToken?: string | null;
}

export interface OdProtosVariantData_Grain_PropertyGrainInput {
  primaryId?: OdProtosVariantData_Grain_PropertyGrain_PrimaryIdOneofInput | null;
  temporaryId?: OdProtosVariantData_Grain_PropertyGrain_TemporaryIdOneofInput | null;
}

export interface OdProtosVariantData_Grain_PropertyGrain_PrimaryIdOneofInput {
  addressToken?: string | null;
}

export interface OdProtosVariantData_Grain_PropertyGrain_TemporaryIdOneofInput {
  propertyEngagementId?: string | null;
}

/**
 * LeadParams represents parameters to query a lead by (e.g. address token and customer uuid).
 * Next ID: 3
 */
export interface OdProtosWebData_LeadQueryParamsInput {
  addressToken?: string | null;
  customerUuid?: string | null;
}

/**
 * Which system generated the lead.
 * Next ID: 3
 */
export interface OdProtosWebData_LeadSourceInput {
  type?: OdProtosWebData_LeadSource_Type | null;
  id?: string | null;
}

/**
 * Next ID: 2
 */
export interface OdProtosWebData_ParticipantRolesForAccessInput {
  participantRolesForAccess?: OdProtosWebData_ParticipantRole[] | null;
}

/**
 * Request/Response objects for GetLead
 * Next ID: 7
 */
export interface OdProtosWebServicesSellDirect_GetLeadRequestInput {
  lead?: OdProtosWebServicesSellDirect_GetLeadRequest_LeadOneofInput | null;
  userEmailForAccess?: string | null;
  participantRolesForAccess?: OdProtosWebData_ParticipantRolesForAccessInput | null;
}

export interface OdProtosWebServicesSellDirect_GetLeadRequest_LeadOneofInput {
  source?: OdProtosWebData_LeadSourceInput | null;
  params?: OdProtosWebData_LeadQueryParamsInput | null;
  token?: string | null;
  sellerLeadUuid?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
